export default "/images/vendor/flag-icons/flags/1x1/gy.svg?e28d1b4b1a434168df636b352b5616da";